module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-59-min.8ef25f41.jpg";